import request from '@/utils/request'

const guaranteeContractApi = {
  trade_guarantee_contract_list: '/trade/guarantee_contract/',
  trade_guarantee_contract_create: '/trade/guarantee_contract/',
  trade_guarantee_contract_update: '/trade/guarantee_contract/',
  trade_guarantee_contract_delete: '/trade/guarantee_contract/',
  trade_guarantee_contract_archived: '/trade/guarantee_contract_archived/',
  trade_guarantee_contract_attachment: '/trade/guarantee_contract_attachment/'
}

/**
 * 列表
 */
export function guarantee_contract_list (parameter) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function guarantee_contract_create (parameter) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function guarantee_contract_update (parameter, guarantee_contract_id) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_update + guarantee_contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function guarantee_contract_delete (guarantee_contract_id) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_delete + guarantee_contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function guarantee_contract_archived (parameter) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
* 担保合同附件列表
* @param parameter
* @returns {AxiosPromise}
*/
export function guarantee_contract_attachment_list (parameter) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 担保合同附件添加
 */
export function guarantee_contract_attachment_create (parameter) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件删除
 */
export function guarantee_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: guaranteeContractApi.trade_guarantee_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
